import { pathOr } from 'ramda';
import React, { useMemo, useState, useContext } from 'react';
import { MinimalDocumentArtifacts } from '../Advisors/Settings/ManageAccess/Documents/documents';
import { VarMapsHandler } from '../Advisors/Settings/Global/VarMaps/VarMaps';


//TODO: rewrite context!!
interface PermissionContextDataType {
    permissions: any[];
    rolesPermissions: any[];
    globalPermissions: any[];
    loanProducts: any[];
    podConfigs: any[];
    documentAccessControls: any[];
    miniGlobalDocumentArtifacts: MinimalDocumentArtifacts;
    varmaps: any[];
    branches?: Object[] | undefined;
    authenticatedBranches?: Object[],
    teams?: Object[];
    allAdvisors?: Object[];
}

interface PermissionContextProviderType {
    children: React.ReactNode,
    default?: PermissionContextDataType
}

interface PermissionContextSetter {
    setPermissions: (_: any) => void;
    setVarMaps?: (_: any) => void;
    setAdvisorProfiles?: (_: any) => void;
}

type PermissionContextType = PermissionContextDataType & PermissionContextSetter

export const PermissionContext = React.createContext<PermissionContextType>({
    permissions: [],
    rolesPermissions: [],
    globalPermissions: [],
    loanProducts: [],
    podConfigs: [],
    branches: [],
    authenticatedBranches: [],
    setPermissions: (_: any) => { },
    documentAccessControls: [],
    miniGlobalDocumentArtifacts: new MinimalDocumentArtifacts([]),
    teams: [],
    setVarMaps: (_: any) => { },
    varmaps: [],
    setAdvisorProfiles: (_: any) => { },
    allAdvisors: []
});

// NOTE: default props here is HOTFIX, meant only for the root component
// TODO: Replace all permission context with this provider
// Add additional setters to handle other state values i.e. setLoanProducts, setpodConfigs
export const PermissionContextProvider = (props: PermissionContextProviderType) => {
    const [value, setValue] = useState<PermissionContextDataType>({
        permissions: pathOr([], ["default", "permissions"], props),
        rolesPermissions: pathOr([], ["default", "rolesPermissions"], props),
        globalPermissions: pathOr([], ["default", "globalPermissions"], props),
        miniGlobalDocumentArtifacts: pathOr(new MinimalDocumentArtifacts([]), ["default", "miniGlobalDocumentArtifacts"], props), 
        loanProducts: pathOr([], ["default", "loanProducts"], props),
        podConfigs: pathOr([], ["default", "podConfigs"], props),
        documentAccessControls: pathOr([], ["default", "documentAccessControls"], props),
        branches: pathOr([], ["default", "branches"], props),
        authenticatedBranches: pathOr([], ["default", "authenticatedBranches"], props),
        teams: pathOr([], ["default", "teams"], props),
        varmaps: pathOr([], ["default", "varmaps"], props),
    })

    const setPermissions = (permissions: any[]) => {
        setValue(prev => {
            return {
                ...prev,
                permissions
            }
        })
    }

    const setVarMaps = (varmaps: any[]) => {
        setValue(prev => {
            return {
                ...prev,
                varmaps
            }
        })
    }

    const setAdvisorProfiles = (allAdvisors: any[]) => {
        setValue(prev => {
            return {
                ...prev,
                allAdvisors
            }
        })
    }

    const contextValues = useMemo(() => {
        return {
            ...value,
            setPermissions,
            setVarMaps,
            setAdvisorProfiles
        }
    }, [value])

    return <PermissionContext.Provider value={contextValues}>
        {props.children}
    </PermissionContext.Provider>
}

export const usePermissionContext = () => {
    const context = useContext(PermissionContext);
    return {
        ...context,
        varMapHander: new VarMapsHandler(context.varmaps) 
    }
}